/**

 */
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchPricingConfig } from './actions/pricingActions';

/**
Component Imports
 */
import Header from './components/Header';
import Footer from './components/Footer';

import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import AboutusScreen from './screens/AboutusScreen';
import LoginScreen from './screens/LogininScreen';
import RegisterScreen from './screens/RegisterScreen';
import ProfileScreen from './screens/ProfileScreen';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import OrderHistoryScreen from './screens/OrderHistoryScreen';
import AdminDashboardScreen from './screens/AdminDashboardScreen';
import ProductListScreen from './screens/ProductListScreen';
import OrderListScreen from './screens/OrderListScreen';
import UserListScreen from './screens/UserListScreen';
import CustomizationListScreen from './screens/CustomizationListScreen';
import AdminGenaiJobListScreen from './screens/AdminGenaiJobListScreen';
import AdminGenaiJobDetailScreen from './screens/AdminGenaiJobDetailScreen';
import AdminMetricsScreen from './screens/AdminMetricsScreen';
import BookInputScreen from './screens/BookInputScreen';
import MyGeneratedBooksScreen from './screens/MyGeneratedBooksScreen';
import StoryReviewScreen from './screens/StoryReviewScreen';
import PagesReviewScreen from './screens/PagesReviewScreen';
import FinalBookScreen from './screens/FinalBookScreen';
import GenaiJobRedirectScreen from './screens/GenaiJobRedirectScreen';
import BookFormatGuideScreen from './screens/BookFormatGuideScreen';
import FaqScreen from './screens/FaqScreen';
import ContactScreen from './screens/ContactScreen';
/**
App Component
 */

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPricingConfig());
  }, [dispatch]);

  return (
    <Router>
      <Header />
      <main className='py-3'>
        <Container>
          <Routes>
            <Route path="/" element={<HomeScreen />} exact />
            <Route path="/about" element={<AboutusScreen />} />
            <Route path="/products" element={<HomeScreen />} />
            <Route path="/product/:id" element={<ProductScreen />} />
            <Route path="/cart/:id?" element={<CartScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/login/:redirect" element={<LoginScreen />} />
            <Route path="/register" element={<RegisterScreen />} />
            <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
            <Route path="/reset-password" element={<ResetPasswordScreen />} />
            <Route path="/profile" element={<ProfileScreen />} />
            <Route path="/shipping" element={<ShippingScreen />} />
            <Route path="/payment" element={<PaymentScreen />} />
            <Route path="/placeorder" element={<PlaceOrderScreen />} />
            <Route path="/order/:id" element={<OrderScreen />} />
            <Route path="/orders" element={<OrderHistoryScreen />} />
            
            {/* GenAI Book Creation Routes */}
            <Route path="/genai/create_story" element={<BookInputScreen />} />
            <Route path="/genai/jobs" element={<MyGeneratedBooksScreen />} />
            <Route path="/genai/job/:jobId" element={<GenaiJobRedirectScreen />} />
            <Route path="/genai/book-guide" element={<BookFormatGuideScreen />} />
            <Route path="/genai/job/:jobId/review-story" element={<StoryReviewScreen />} />

            <Route path="/genai/job/:jobId/review-pages" element={<PagesReviewScreen />} />
            <Route path="/genai/job/:jobId/final-review" element={<FinalBookScreen />} />
            
            <Route path="/faq" element={<FaqScreen />} />
            <Route path="/contact" element={<ContactScreen />} />

            {/* Admin Routes */}
            <Route path="/admin/dashboard" element={<AdminDashboardScreen />} />
            <Route path="/admin/products" element={<ProductListScreen />} />
            <Route path="/admin/orders" element={<OrderListScreen />} />
            <Route path="/admin/users" element={<UserListScreen />} />
            <Route path="/admin/customizations" element={<CustomizationListScreen />} />
            <Route path="/admin/genai/jobs" element={<AdminGenaiJobListScreen />} />
            <Route path="/admin/genai/jobs/:jobId" element={<AdminGenaiJobDetailScreen />} />
            <Route path="/admin/metrics" element={<AdminMetricsScreen />} />
          </Routes>
        </Container>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
